import { Box, ColorOptions, Icon, ModBox, SpacerNew, TextNew } from '@jfs/ui-new'
import React, { useEffect } from 'react'
import { DualActionButtonComp } from '../../../../components/DualActionButtonComp'
import { useStores } from '../../../../data/store'
import { bulkEntityStringConstants } from '../../../../utils/constants'
import { SelectParentEntityList } from '../../Onboarding/CreateEntity/SelectParentEntityList'
import {
  flexMapperSyncBulkFileContent,
  flexMapperWithIndex,
  flexMapperWithIndexFileContent,
  headerData,
  headerDataFileContent,
  syncBulkFileContent,
} from './Fixtures'
import { styles } from './styles'

interface UploadedFileDetailsInterface {
  onSubmitPress: () => void
  onUploadNewFilePress: () => void
  type: 'bulkUpload' | 'tid' | 'bulkConfig' | 'bulkCard' | 'bulkVpa' | 'bulkStore' | 'bulkTerminal'
}

const UploadedFileDetails = React.memo(
  ({ onSubmitPress, onUploadNewFilePress, type }: UploadedFileDetailsInterface) => {
    const { getUploadedFileDetails } = useStores((root) => ({
      getUploadedFileDetails: root.bulkEntity.getUploadedFileDetails,
    }))

    // const [fileDetailLoader, toggleFileDetailLoader] = useState(false)

    useEffect(() => {
      // toggleFileDetailLoader(true)
      // getUploadedBulkFileDetails()
    }, [])

    const statusTitle =
      type === 'bulkUpload'
        ? "Your 'Bulk Entities' creation application submitted and is pending for approval. \nYou can check further status from your Application Queue"
        : type === 'bulkConfig'
        ? "Your 'Bulk Config' application is submitted"
        : type === 'bulkCard'
        ? "Your 'Bulk Cards' application is submitted"
        : type === 'bulkVpa'
        ? "Your 'Bulk VPA' application is submitted"
        : type === 'bulkStore'
        ? "Your 'Bulk Store' application is submitted"
        : type === 'bulkTerminal'
        ? "Your 'Bulk Terminal' application is submitted"
        : bulkEntityStringConstants[type].sucessStatusText
        ? bulkEntityStringConstants[type].sucessStatusText
        : "Your 'Sync Bulk Entities' application is submitted"

    return (
      <Box height={'100%'}>
        <Box {...styles.boxContainer} overflow="auto" flex={1}>
          <ModBox w={'100%'} alignItems={'center'} justifyContent={'center'}>
            <ModBox
              w={64}
              h={64}
              borderRadius={32}
              backgroundColor={'#FBEDD6' as ColorOptions}
              alignItems={'center'}
              justifyContent={'center'}>
              <Icon id={'TIMER'} color={'ORANGE'} size={32} />
            </ModBox>
            <ModBox marginTop={32} alignItems={'center'}>
              <TextNew
                title={statusTitle}
                color={'BLACK_21'}
                fontSize={16}
                fontFamily={'jiotype-bold'}
                textAlign={'center'}
              />
            </ModBox>
          </ModBox>
          <ModBox show={false} h={476}>
            <TextNew title={bulkEntityStringConstants[type].uploadFileDetails} {...styles.headerTitle} />
            <SpacerNew size={2} />
            <SelectParentEntityList
              title={''}
              hide={false}
              data={[getUploadedFileDetails()]}
              headerTitles={headerData}
              columnFlexMapper={flexMapperWithIndex}
            />
            <SpacerNew size={40} />
            <Box {...styles.rowContainer}>
              <TextNew title={bulkEntityStringConstants[type].fileContent} {...styles.headerTitle} />
              <SpacerNew size={15} direction={'horizontal'} />
              <Box {...styles.failedContainer}>
                <TextNew title={`${bulkEntityStringConstants[type].failedEntry} : 1`} {...styles.failedText} />
              </Box>
            </Box>
            <SelectParentEntityList
              title={''}
              hide={false}
              data={type === 'bulkUpload' ? [] : []}
              headerTitles={type === 'bulkUpload' ? headerDataFileContent : syncBulkFileContent}
              columnFlexMapper={type === 'bulkUpload' ? flexMapperWithIndexFileContent : flexMapperSyncBulkFileContent}
            />
          </ModBox>
          <SpacerNew size={40} />
        </Box>
        <DualActionButtonComp
          isOutlineButtonVisible={true}
          isColoredButtonVisible={true}
          isValid={true}
          outlineButtonTitle={bulkEntityStringConstants[type].uploadNewFile}
          coloredButtonText={bulkEntityStringConstants[type].done}
          onColoredButtonPress={onSubmitPress}
          onOutlineButtonPress={onUploadNewFilePress}
        />
      </Box>
    )
  },
)

export { UploadedFileDetails }
